<template>
	<div class="login-page">
		<div class="login-shell">
			<div class="brand-title-row">
				<img class="brand-logo" :src="logoUrl" alt="logo" />
				<h1 class="brand-name">驾驶人体检服务平台</h1>
			</div>

			<section class="login-card">
				<div class="card-head">
					<h2 class="card-title">登录</h2>
					<p class="card-hint">使用账号密码进入系统</p>
				</div>

				<div class="field-stack">
					<label class="field-label">账号</label>
					<el-input
						class="ds-input"
						v-model="account"
						placeholder="请输入账号"
						prefix-icon="el-icon-user"
						clearable>
					</el-input>

					<label class="field-label">密码</label>
					<el-input
						class="ds-input"
						v-model="password"
						placeholder="请输入密码"
						prefix-icon="el-icon-lock"
						show-password
						@keyup.enter.native="login()">
					</el-input>

					<el-button class="login-btn" type="primary" @click="login()">登录</el-button>
				</div>

				<div class="login-meta">
					<el-checkbox v-model="rememberPassword" class="remember-check">记住密码</el-checkbox>
					<button type="button" class="link-btn" @click="ChangePassword()">修改密码</button>
				</div>
			</section>

			<p class="brand-desc">好好生活，因为总有个人惦记着你。</p>

			<footer class="login-footer">
				深圳市美铭科技有限公司 © 2026
				<a class="beian-link" href="https://beian.miit.gov.cn" target="_blank" rel="noopener">粤ICP备18082632号</a>
			</footer>
		</div>

		<el-dialog
			class="pwd-dialog"
			title="修改密码"
			:visible.sync="dialogFormVisible"
			width="420px"
			:show-close="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false">
			<el-form :model="form" ref="form" label-width="130px" :rules="rules">
				<el-form-item label="账号">
					<el-input v-model="form.account_" placeholder="账号(必填项)"></el-input>
				</el-form-item>
				<el-form-item label="旧密码">
					<el-input v-model="form.password_" placeholder="旧密码(必填项)" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码">
					<el-input v-model="form.newPassword_" placeholder="新密码(必填项)" show-password></el-input>
				</el-form-item>
				<el-form-item label="再次确认新密码">
					<el-input v-model="form.newPassword2_" placeholder="再次确认新密码(必填项)" show-password></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" class="dialog-primary" @click="submitForm('form')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import gmCrypt from 'gm-crypt';
	import {
		get,
		post
	} from '../../../public/request/request.js';
	import axios from 'axios';
	import logoUrl from '../../assets/logo.png';

	export default {
		data() {
			return {
				logoUrl,
				account: "",
				password: "",
				rememberPassword: false,
				form: {},
				dialogFormVisible: false,
			};
		},
		created() {
		},
		methods: {
			login() {
				if (this.account == '' || this.password == '') {
					this.$message.error('账号和密码不能为空');
					return;
				} else if (!this.check()) {
					//this.$message.error('密码至少包含英文字符、数字及特殊符号，长度不小于8位');
					//return;
				}

				this.$message({
					message: '正在登录...',
					center: true
				});
				const loading = this.openLoading();
				post('101', {
						account: this.account,
						password: this.password,
						siteChannelType: 2
					})
					.then(response => {
						if (response.data.result == 0) {
							const user = response.data.data.user || {};
							// ROLE.SUPER = 0；登录用户字段为 role
							const roleId = user.role != null ? Number(user.role) : Number(user.userRoleId);
							const isSuper = roleId === 0;
							// 疏漏修复：旧接口无 channelType 时为 undefined，`undefined != null` 为 false 会跳过校验。
							// 缺失时按体检平台(1)处理，禁止进入 Printers（超管除外）。
							const channelType = (user.channelType !== undefined && user.channelType !== null && user.channelType !== '')
								? Number(user.channelType)
								: 1;
							if (channelType !== 2 && !isSuper) {
								sessionStorage.removeItem('loginInfo');
								sessionStorage.removeItem('channelType');
								sessionStorage['_token'] = '';
								sessionStorage['_login'] = 'false';
								this.$message.error('请从对应平台入口登录（本站仅服务平台账号）');
								loading.close();
								return;
							}

							sessionStorage.setItem('loginInfo',JSON.stringify(user));
							sessionStorage.setItem('channelType', String(channelType));
							sessionStorage['_token'] = response.data.data.token;
							sessionStorage['_login'] = 'true';

							if (response.data.data.allowChannel !== undefined) {
								sessionStorage.setItem('allowChannel', response.data.data.allowChannel ? 'true' : 'false');
							} else {
								sessionStorage.setItem('allowChannel', 'true');
							}
							
							if (this.rememberPassword) {
								localStorage.setItem('rememberedAccount', this.account);
								localStorage.setItem('rememberedPassword', this.password);
								localStorage.setItem('rememberPassword', 'true');
							} else {
								localStorage.removeItem('rememberedAccount');
								localStorage.removeItem('rememberedPassword');
								localStorage.removeItem('rememberPassword');
							}
							
							post(201, null)
								.then(response => {
									if (response.data.result == 0) {
										this.$setAuthority(response.data.data);
										this.$router.push({
											path: '/home'
										});
										loading.close();
									} else {
										this.$message.error('查询数据失败.:' + response.data.message);
										loading.close();
									}
								})
								.catch(error => {
									this.$message.error((error && error.userMessage) || '查询数据失败。');
									loading.close();
								});
						} else if (response.data.errorcode == 1028) {
							this.$alert(response.data.message, {
								title: '提示',
								showClose: false,
								callback: action => {
									this.form = {
										account_: this.account,
										password_: this.password,
										newPassword_: "",
										newPassword2_: ""
									};
									this.dialogFormVisible = true;
								},
							});
							loading.close();
						} else {
							this.$message.error('登录失败：' + response.data.message);
							loading.close();
						}
					})
					.catch(error => {
						sessionStorage['_token'] = "";
						sessionStorage['_login'] = 'false';
						this.$message.error((error && error.userMessage) || '登录失败');
						console.error('There was an error!', error);
						loading.close();
					});
			},
			check() {
				if (this.password == '') {
					return false;
				}
				var pattern = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.?;:_=+-]).{8,}$/;
				return pattern.test(this.password);
			},
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
			ChangePassword() {
				this.form = {
					account_: this.account,
					password_: "",
					newPassword_: "",
					newPassword2_: ""
				};
				this.dialogFormVisible = true;
			},
			submitForm() {
				if (this.form.account_ != "" && this.form.password_ != "" && this.form.newPassword_ != "" && this.form
					.newPassword2_) {
					if (this.form.newPassword_ == this.form.newPassword2_) {
						if (this.form.password_ != this.form.newPassword_) {
							var pattern = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.?;:_=+-]).{8,}$/;
							if (pattern.test(this.form.newPassword_)) {
								let params = {
									account: this.form.account_,
									password: this.form.password_,
									newPassword: this.form.newPassword_
								};

								const loading = this.openLoading();
								post(102, params)
									.then(response => {
										if (response.data.result == 0) {
											this.$message.success('修改密码成功');
											loading.close();
											this.dialogFormVisible = false;
										} else {
											this.$message.error('操作失败.:' + response.data.message);
											loading.close();
										}
									})
									.catch(error => {
										this.$message.error((error && error.userMessage) || '操作失败。');
										loading.close();
									});
							} else {
								this.$message.error('密码至少包含英文字符、数字及特殊符号，长度不小于8位');
							}
						} else {
							this.$message.error('新密码不能和旧密码相同');
						}
					} else {
						this.$message.error('两次输入的新密码不一致');
					}
				} else {
					this.$message.error('必填项不能为空');
				}
			},
		},
		mounted() {
			const rememberedAccount = localStorage.getItem('rememberedAccount');
			const rememberedPassword = localStorage.getItem('rememberedPassword');
			const rememberPasswordFlag = localStorage.getItem('rememberPassword');
			
			if (rememberPasswordFlag === 'true' && rememberedAccount && rememberedPassword) {
				this.account = rememberedAccount;
				this.password = rememberedPassword;
				this.rememberPassword = true;
			}
		},
	}
</script>

<style>
	@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;700&display=swap');

	.login-page {
		--bg: #2A2A2A;
		--surface: #262626;
		--surface-2: #2C2C2C;
		--border: rgba(255, 255, 255, 0.08);
		--text: rgba(255, 255, 255, 0.92);
		--text-muted: rgba(255, 255, 255, 0.48);
		--accent: #4A9EFF;
		--accent-soft: rgba(74, 158, 255, 0.16);
		--shadow: 0 12px 40px rgba(0, 0, 0, 0.35);

		position: relative;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		background: var(--bg);
		color: var(--text);
		font-family: 'Manrope', 'Noto Sans SC', system-ui, -apple-system, 'Segoe UI', sans-serif;
	}

	.login-page::before {
		content: '';
		position: absolute;
		width: 520px;
		height: 520px;
		right: -160px;
		top: -180px;
		border-radius: 50%;
		background: radial-gradient(
			circle,
			rgba(74, 158, 255, 0.14) 0%,
			rgba(74, 158, 255, 0.09) 22%,
			rgba(74, 158, 255, 0.05) 42%,
			rgba(74, 158, 255, 0.02) 62%,
			rgba(74, 158, 255, 0) 78%
		);
		filter: blur(48px);
		pointer-events: none;
	}

	.login-page::after {
		content: '';
		position: absolute;
		width: 780px;
		height: 780px;
		left: -280px;
		top: 50%;
		transform: translateY(-50%);
		border-radius: 50%;
		background: radial-gradient(
			circle,
			rgba(74, 158, 255, 0.14) 0%,
			rgba(74, 158, 255, 0.09) 22%,
			rgba(74, 158, 255, 0.05) 42%,
			rgba(74, 158, 255, 0.02) 62%,
			rgba(74, 158, 255, 0) 78%
		);
		filter: blur(64px);
		pointer-events: none;
	}

	.login-shell {
		position: relative;
		z-index: 1;
		width: 100%;
		height: 100%;
		margin: 0 auto;
		padding: 40px 28px 28px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 20px;
	}

	.brand-title-row {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 14px;
		max-width: min(520px, 100%);
		animation: riseIn 0.55s ease both;
	}

	.brand-logo {
		width: 44px;
		height: 44px;
		object-fit: contain;
		flex-shrink: 0;
		display: block;
	}

	.brand-name {
		margin: 0;
		font-size: clamp(22px, 3vw, 32px);
		font-weight: 700;
		line-height: 1.25;
		letter-spacing: -0.02em;
		color: var(--text);
		text-align: left;
	}

	.login-card {
		width: min(400px, 100%);
		padding: 28px 26px 24px;
		border-radius: 18px;
		background: var(--surface);
		border: 1px solid var(--border);
		box-shadow: var(--shadow);
		animation: riseIn 0.55s ease 0.08s both;
	}

	.brand-desc {
		margin: 0;
		max-width: min(400px, 100%);
		font-size: 15px;
		line-height: 1.7;
		font-weight: 400;
		color: var(--text-muted);
		text-align: center;
		animation: riseIn 0.55s ease 0.12s both;
	}

	@keyframes riseIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.card-head {
		margin-bottom: 22px;
	}

	.card-title {
		margin: 0;
		font-size: 22px;
		font-weight: 650;
		letter-spacing: -0.01em;
	}

	.card-hint {
		margin: 8px 0 0;
		font-size: 13px;
		color: var(--text-muted);
	}

	.field-stack {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.field-label {
		margin-top: 6px;
		font-size: 13px;
		font-weight: 500;
		color: rgba(255, 255, 255, 0.62);
	}

	.ds-input {
		width: 100%;
		margin-bottom: 6px;
	}

	.ds-input .el-input__inner {
		height: 44px;
		line-height: 44px;
		border-radius: 10px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		background: var(--surface-2);
		color: var(--text);
		font-family: inherit;
		font-size: 14px;
		padding-left: 40px;
		transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
	}

	.ds-input .el-input__inner::placeholder {
		color: rgba(255, 255, 255, 0.32);
	}

	.ds-input .el-input__inner:hover {
		border-color: rgba(255, 255, 255, 0.18);
	}

	.ds-input .el-input__inner:focus {
		border-color: var(--accent);
		background: #303030;
		box-shadow: 0 0 0 3px var(--accent-soft);
	}

	.ds-input .el-input__prefix {
		left: 10px;
	}

	.ds-input .el-input__prefix .el-input__icon,
	.ds-input .el-input__suffix .el-input__icon {
		line-height: 44px;
		color: rgba(255, 255, 255, 0.42);
		transition: color 0.2s ease;
	}

	.ds-input .el-input__inner:focus ~ .el-input__prefix .el-input__icon,
	.ds-input.is-focus .el-input__prefix .el-input__icon {
		color: var(--accent);
	}

	.login-btn {
		width: 100%;
		height: 44px;
		margin-top: 12px;
		border: none;
		border-radius: 10px;
		font-family: inherit;
		font-size: 15px;
		font-weight: 600;
		letter-spacing: 0.04em;
		color: #0b1220;
		background: var(--accent);
		box-shadow: 0 8px 20px rgba(74, 158, 255, 0.22);
		transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
	}

	.login-btn:hover,
	.login-btn:focus {
		background: #63adff;
		color: #0b1220;
		transform: translateY(-1px);
		box-shadow: 0 10px 24px rgba(74, 158, 255, 0.28);
	}

	.login-btn:active {
		transform: translateY(0);
		background: #3d8ff0;
	}

	.login-meta {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 16px;
	}

	.remember-check .el-checkbox__label {
		color: var(--text-muted);
		font-family: inherit;
		font-size: 13px;
		padding-left: 8px;
	}

	.remember-check .el-checkbox__inner {
		background: transparent;
		border-color: rgba(255, 255, 255, 0.28);
		border-radius: 4px;
	}

	.remember-check.is-checked .el-checkbox__inner {
		background-color: var(--accent);
		border-color: var(--accent);
	}

	.remember-check.is-checked .el-checkbox__inner::after {
		border-color: #0b1220;
	}

	.link-btn {
		border: none;
		background: transparent;
		padding: 0;
		cursor: pointer;
		font-family: inherit;
		font-size: 13px;
		font-weight: 600;
		color: var(--accent);
		transition: color 0.2s ease, opacity 0.2s ease;
	}

	.link-btn:hover {
		color: #79baff;
	}

	.login-footer {
		margin-top: 8px;
		text-align: center;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.28);
	}

	.beian-link {
		margin-left: 8px;
		color: rgba(255, 255, 255, 0.42);
		text-decoration: none;
		transition: color 0.2s ease;
	}

	.beian-link:hover {
		color: var(--accent);
	}

	.pwd-dialog .el-dialog {
		background: var(--surface);
		border: 1px solid var(--border);
		border-radius: 14px;
		box-shadow: var(--shadow);
	}

	.pwd-dialog .el-dialog__title {
		color: var(--text);
		font-family: inherit;
		font-weight: 650;
	}

	.pwd-dialog .el-form-item__label {
		color: rgba(255, 255, 255, 0.65);
	}

	.pwd-dialog .el-input__inner {
		background: var(--surface-2);
		border-color: rgba(255, 255, 255, 0.1);
		color: var(--text);
	}

	.pwd-dialog .el-input__inner:focus {
		border-color: var(--accent);
	}

	.pwd-dialog .dialog-primary,
	.pwd-dialog .el-button--primary {
		background: var(--accent);
		border-color: var(--accent);
		color: #0b1220;
	}

	.pwd-dialog .el-button--default {
		background: transparent;
		border-color: rgba(255, 255, 255, 0.18);
		color: rgba(255, 255, 255, 0.72);
	}

	@media (max-width: 520px) {
		.brand-title-row {
			flex-direction: column;
			gap: 10px;
			text-align: center;
		}

		.brand-name {
			font-size: 22px;
			text-align: center;
		}
	}
</style>
